module.exports = __webpack_public_path__ + "img/sa.80a16c9f.svg";